/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AnagraficaService } from '@shared/services/anagrafica.service';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PagesGestioneOperaCreaOperaResolver implements Resolve<Observable<any>> {

    constructor(
        private anagraficaService: AnagraficaService,
    ) { }

    resolve(): Observable<any> {
        return forkJoin([
            this.anagraficaService.getComuni(),
            this.anagraficaService.getClassificazioneOpera(),
            this.anagraficaService.getImportanzaOpera(),
            this.anagraficaService.getMacroTipologiaOpera(),
            this.anagraficaService.getMateriale(),
            this.anagraficaService.getProvince(),
            this.anagraficaService.getSponda(),
            this.anagraficaService.getTipologiaOpera(),
            this.anagraficaService.getTipoShape(),
            // this.anagraficaService.getProvenienza(),
            this.anagraficaService.getFunzionePrevalente(),
            this.anagraficaService.getStatoOpera()
        ]).pipe(
            map(([
                responseAnagraficaComuni,
                responseAnagraficaClassificazioneOpera,
                responseAnagraficaImportanzaOpera,
                responseAnagraficaMacroTipologiaOpera,
                responseAnagraficaMateriale,
                responseAnagraficaProvince,
                responseAnagraficaSponda,
                responseAnagraficaTipologiaOpera,
                responseAnagraficaTipoShape,
                // responseAnagraficaProvenienza,
                responseAnagraficaFunzionePrevalente,
                responseAnagraficaStatoOpera

            ]) => {
                return {
                    datalist: {
                        comuni: responseAnagraficaComuni,
                        classificazioneOpera: responseAnagraficaClassificazioneOpera,
                        importanzaOpera: responseAnagraficaImportanzaOpera,
                        macroTipologiaOpera: responseAnagraficaMacroTipologiaOpera,
                        materiale: responseAnagraficaMateriale,
                        province: responseAnagraficaProvince,
                        sponda: responseAnagraficaSponda,
                        tipologiaOpera: responseAnagraficaTipologiaOpera,
                        tipoShape: responseAnagraficaTipoShape,
                        // provenienza: responseAnagraficaProvenienza,
                        funzionePrevalente: responseAnagraficaFunzionePrevalente,
                        statoOpera: responseAnagraficaStatoOpera
                    },
                };
            }),
        );
    }

}